import { render, staticRenderFns } from "./reporte-accidentes-editar.vue?vue&type=template&id=0039ac6a&scoped=true&"
import script from "./reporte-accidentes-editar.vue?vue&type=script&lang=js&"
export * from "./reporte-accidentes-editar.vue?vue&type=script&lang=js&"
import style0 from "./reporte-accidentes-editar.vue?vue&type=style&index=0&id=0039ac6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0039ac6a",
  null
  
)

export default component.exports